const {
  utils: { clamp, lerp },
} = require("pex-math");

const random = require("pex-random");
const splinePoints = require("spline-points");
const cubicInOut = require("eases").cubicInOut;

function range(start, end) {
  if (!end) {
    end = start;
    start = 0;
  }
  return Array.from({ length: end - start }).map((_, i) => start + i);
}

function generateRings({ data, normalizeSize = true, subdivide = false }) {
  random.seed(data.id);

  const numAxis = data.rings[0].radius.length;

  let maxRadius = data.rings[data.rings.length - 1].radius.reduce(
    (max, r) => Math.max(max, r),
    0
  );

  const normalizationFactor = normalizeSize ? 0.5 / maxRadius : 1 / 250;

  const rings = [];
  const numRings = data.rings.length;
  const R = 10;
  for (let i = 0; i < numRings; i++) {
    const ring = data.rings[i];
    const points = [];

    for (let j = 0; j < numAxis; j++) {
      const r = R * (ring.radius[j % numAxis] * normalizationFactor);
      const a = (j / numAxis) * Math.PI * 2;
      const x = r * Math.cos(a);
      const y = r * Math.sin(a);
      points.push([x, y, 0]);
    }
    rings.push({
      spline: subdivide
        ? splinePoints(points, { segmentLength: 0.05, closed: true })
        : points,
      ring: data.rings[i],
    });
  }

  return [rings, normalizationFactor];
}

let delays = range(0, 40).map((i) => {
  return i / 10 + random.float(0, 1);
});
let reveals = range(0, 40).map(() => random.float(0, 0));
let offsets = range(0, 40).map(() => random.float(0, 1));

function resetAnim() {
  delays = range(0, 40).map((i) => {
    return i / 10 + random.float(0, 1);
  });
  reveals = range(0, 40).map(() => random.float(0, 0));
  offsets = range(0, 40).map(() => random.float(0, 1));
}
resetAnim();

function animateRings({
  data,
  baseColor,
  rings,
  thicknessReveal = 0,
  thicknessRandom = 0,
  reveal = 1,
  deltaTime = 1 / 30,
  isPaused = true,
}) {
  const positions = [];
  const vertexColors = [];

  random.seed(0);

  rings.forEach((ring, i) => {
    let thickness = lerp(1, ring.ring.thickness, thicknessReveal);
    thickness +=
      Math.sin(thicknessRandom * Math.PI) *
      3 *
      (0.5 + 0.4) *
      random.noise3(i / 5, 0, -thicknessRandom * 2.0);
    thickness *= 10;
    const color = [...baseColor];
    color[3] = thickness;

    if (!isPaused) {
      delays[i] -= deltaTime * 0.5;
      if (delays[i] < 0) {
        reveals[i] += deltaTime * 0.295;
        reveals[i] = Math.min(reveals[i], 1);
      }
    }
    let spline = ring.spline;
    const startj = Math.floor(offsets[i] * spline.length);
    let revealAmount = isPaused
      ? clamp(0.5 + reveal * 6.0 - delays[i], 0, 1)
      : reveals[i];

    const endj =
      Math.floor(
        Math.min(1 + offsets[i], offsets[i] + cubicInOut(revealAmount)) *
          spline.length
      ) + 1;

    for (let j = startj; j < endj; j++) {
      const p = [...spline[j % spline.length]];
      p[2] = cubicInOut(1 - revealAmount);
      p[2] = Math.pow(p[2], 2);
      positions.push(p);
      vertexColors.push(color);
    }
    positions.push([0, 0, 0]);
    vertexColors.push(color);
  });

  return {
    positions,
    vertexColors,
  };
}

export { generateRings, animateRings };
